<template>
    <div class="loginbody modulewrap" :style="'background:url('+loginbg+')'">
        <div class="loginwrap">
            <div class="loginhome"><router-link to="/" :title="$common.dicword('homepage')"><i class="iconfont icon-home"></i></router-link></div>
            <div class="loginbg">
                <img :src="loginimg" />
            </div>
            <div class="loginlayer">
                <div class="loginarrow"></div>

                <div class="loginform">
                    <div class="logintitle">{{$common.dicword('memberreg')}}</div>
                    <div class="logininput">
                        <i class="iconfont icon-mobile-phone"></i><input type="text" v-model="logininfo.username" class="txt" :placeholder="$common.dicword('mobile')" maxlength="50" @focus="iserrusername=0" @blur="iserrusername=logininfo.username?0:1" />
                    </div>
                    <div class="loginmsg">{{strerrusername}}</div>
                    <div class="logininput">
                        <i class="iconfont icon-comment"></i><input type="text" v-model="logininfo.vcode" class="txt2" :placeholder="$common.dicword('vcode')" maxlength="50" @focus="iserrvcode=0" @blur="iserrvcode=logininfo.vcode?0:1" /><a href="#" class="btnsms" @click="getvcode">{{vcodetime>0?vcodetime:$common.dicword('sendcode')}}</a>
                    </div>
                    <div class="loginmsg">{{strerrvcode}}</div>
                    <div class="logininput">
                        <i class="iconfont icon-lock"></i><input type="password" v-model="logininfo.pwd" class="txt" :placeholder="$common.dicword('pwd')" maxlength="30" @focus="iserrpwd=0" @blur="iserrpwd=logininfo.pwd?0:1" />
                    </div>
                    <div class="loginmsg">{{strerrpwd}}</div>
                    <div class="logininput">
                        <i class="iconfont icon-lock"></i><input type="password" v-model="pwdconfirm" class="txt" :placeholder="$common.dicword('pwdconfirm')" maxlength="30" @focus="iserrpwdconfirm=0" @blur="iserrpwdconfirm=(logininfo.pwd==pwdconfirm)?0:1" />
                    </div>
                    <div class="loginmsg">{{strerrpwdconfirm}}</div>

                    <div class="logincheck">
                        {{$common.dicword('agreeterm')}} <router-link to="/home/terms">{{$common.dicword('terms')}}</router-link>
                    </div>
                    <div class="loginbtn"><a href="#" @click="submit">{{issubmit?$common.dicword('reging'):$common.dicword('reg')}}</a></div>
                    <div class="loginlink2">{{$common.dicword('ownaccount')}} <router-link to="/home/login">{{$common.dicword('gotologin')}}</router-link></div>

                </div>
            </div>
        </div>
        <Vcode :show="showvcode"
               :img-num="3"
               title="手动小图片到正确位置"
               @success="vcodesuccess"
               @close="showvcode = false" />
    </div>
</template>

<script>
    import Vcode from 'vue-puzzle-vcode';

    export default {
        name: 'signup',
        components: {
            Vcode
        },
        data() {
            return {
                loginbg: '',
                loginimg: '',
                'logininfo': {
                    'username': '',
                    'pwd': '',
                    'vcode': '',
                    'flag': 1
                },
                'pwdconfirm': '',
                'iserrusername': 0,
                'iserrpwd': 0,
                'iserrpwdconfirm': 0,
                'iserrvcode': 0,
                'vcodetime': 0,
                'issubmit': 0,
                'myinterval': '',
                'vcodeerror': 0,
                'showvcode': false
            }
        },
        computed: {
            strerrusername: function () {
                return this.iserrusername == 2 ? this.$common.dicword('mobileerr') : this.iserrusername == 1 ? this.$common.dicword('inputmobile') : '';
            },
            strerrpwd: function () {
                return this.iserrpwd ? this.$common.dicword('needpwd') : '';
            },
            strerrpwdconfirm: function () {
                return this.iserrpwdconfirm ? this.$common.dicword('pwdconfirmerr') : '';
            },
            strerrvcode: function () {
                return this.iserrvcode ? this.$common.dicword('needdvcode') : '';
            }

        },
        methods: {
            vcodesuccess() {
                //this.$common.success('验证成功！正在发送短信')
                this.showvcode = false;
                this.sendSMS()
                // 调用短信接口
            },
            getvcode() {
                if (this.vcodetime == 0) {
                    this.iserrusername = this.logininfo.username ? 0 : 1;
                    if (!this.iserrusername) {
                        this.iserrusername = this.$common.validate(this.logininfo.username, "ismobile") == -1 ? 2 : 0;
                    }
                    if (this.iserrusername == 0) {
                        this.showvcode = true;
                    }
                }

            },
            sendSMS() {
                let jsondata = {
                    'postdata': {
                        'api': 'member', 'act': 'vcodeget', "data": { "t": 1 }, "mobile": this.logininfo.username
                    }, 'msg': ''
                };
                this.$common.post(jsondata, () => {
                    this.vcodetime = 60;
                    this.vcodeerror = 0;
                });
            },
            submit() {

                this.iserrusername = this.logininfo.username == '';
                this.iserrpwd = this.logininfo.pwd == '';
                this.iserrvcode = this.logininfo.vcode == '';
                this.iserrpwdconfirm = this.logininfo.pwd != this.pwdconfirm;

                if (this.vcodeerror < 5) {
                    let isallow = ((!this.iserrusername) && (!this.iserrpwd) && (!this.iserrpwdconfirm) && (!this.iserrvcode));
                    if (isallow) {
                        this.issubmit = true;
                        let jsondata = {
                            'postdata': {
                                'api': 'member', 'act': 'reg', "data": this.logininfo, 'mobile': this.logininfo.username
                            }, 'msg': ''
                        };
                        this.$common.post(jsondata, (res) => {
                            this.$store.dispatch('setislogin', 1);
                            this.$store.dispatch('setmemlev', res.lev);
                            window.location = '/member';
                        }, () => {
                            this.issubmit = false;
                        });
                        this.vcodeerror++;
                    }
                }
                else {
                    this.$common.fetch({ 'act': 'smscodeclear', 'msg': '', 'isautoback': false }, () => { });
                    this.$common.alert('验证码已失效，请重新获取验证码！');
                }

            }

        },
        mounted() {
            this.$emit('showheaderfooter', false);

            let vm = this;
            this.myinterval = window.setInterval(function () {
                if (vm.vcodetime > 0) {
                    vm.vcodetime--;
                }
            }, 1000);


            this.$common.fetch({ 'act': 'tea_signup_img', 'msg': '' }, res => {
                this.loginbg = res.infodata.imgs;
                this.loginimg = res.infodataimg.imgs;
            });

            document.addEventListener('keyup', (e) => {
                var keycode = document.all ? window.event.keyCode : e.which;
                if (keycode == 13) {
                    this.submit();
                }
            });

            this.$common.fetch({ 'act': 'smscodeclear', 'msg': '', 'isautoback': false }, () => { });//清除验证码
        },
        beforeDestroy() {
            window.clearInterval(this.myinterval);
            document.removeEventListener('keyup', () => { return; });
        }
    }
</script>
